
import { getTimeTableColumn } from '@/utils/common/tableColumn'
import i18n from '@/locales'
export default {
  created () {
    this.columns = [
      {
        field: 'src',
        title: i18n.t('scope.text_670'),
        minWidth: 80,
      },
      {
        field: 'dest',
        title: i18n.t('scope.text_671'),
        minWidth: 80,
      },
      {
        field: 'rate',
        title: i18n.t('scope.text_666'),
        minWidth: 80,
      },
      getTimeTableColumn({
        field: 'date',
        title: i18n.t('scope.text_310'),
      }),
    ]
  },
}
